import { Fragment, useEffect, useState } from "react";

import Notification from "components/DigiHapi/Notification";
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_SNACK_MESSAGE } from "actions/types";

export default function SnackBarContainer({
	place = "br",
	snackInfoMsg,
	snackErrorMsg: errorMsg,
	...props
}) {
	const { apiErrorMsg } = useSelector(state => state.errorReducer);
	const dispatch = useDispatch();

	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState(null);
	const [color, setColor] = useState("info");

	const snackErrorMsg = errorMsg || apiErrorMsg;

	useEffect(() => {
		if (snackInfoMsg || snackErrorMsg) {
			setOpen(true);
			setMessage(snackInfoMsg ? snackInfoMsg : snackErrorMsg);
			setColor(snackInfoMsg ? "info" : "danger");
			dispatch({
				type: CLEAR_SNACK_MESSAGE
			});
			if (snackInfoMsg) {
				setTimeout(() => setOpen(false), 5000);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [snackInfoMsg, snackErrorMsg]);

	return (
		<Fragment>
			{props.children}
			<Notification
				place={place}
				color={color}
				message={message}
				open={open}
				onClose={() => setOpen(false)}
			/>
		</Fragment>
	);
}
